// ChefHat — small icon button that signals "this row has a technique or
// note attached". Used on prerequisites list rows and on task
// rectangles. Sage glyph on a transparent background.
//
// The popover content (the note itself) is a Phase 5/6 concern; this
// component is the icon button only.
//
// See README §6.3 (chef-hat on the far right of prereqs rows), §6.7.3
// item 4 (chef-hat icon on task rectangles).

import { theme } from '../theme';

export interface ChefHatProps {
  ariaLabel: string;
  onClick: () => void;
}

export function ChefHat({ ariaLabel, onClick }: ChefHatProps) {
  return (
    <button
      type="button"
      aria-label={ariaLabel}
      onClick={onClick}
      style={{
        width: '44px',
        height: '44px',
        padding: 0,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'transparent',
        border: 'none',
        cursor: 'pointer',
        color: theme.accent.calm,
      }}
    >
      <svg
        viewBox="0 0 24 24"
        width="24"
        height="24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        {/* A minimal chef-hat glyph: dome on top, band on the bottom. */}
        <path d="M6 14c-2 0-3.5-1.5-3.5-3.5S4 7 6 7c0-2.2 1.8-4 4-4s4 1.8 4 4c2 0 3.5 1.5 3.5 3.5S16 14 14 14" />
        <path d="M6 14h12v5a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1z" />
      </svg>
    </button>
  );
}

export default ChefHat;
